import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import React, { Suspense, useState, useEffect, useCallback } from "react";
import shortid from "shortid";
import { NotificationStarting } from "@faire/retailer-visitor-shared/events";
/**
 * Wrapper component that listens for events. See AddToCard for sample use.
 */ export var EventListener = function(param) {
    var event = param.event, eventFinish = param.eventFinish, eventHandlerElement = param.eventHandlerElement, shouldIgnoreEvent = param.shouldIgnoreEvent;
    var _useState = _sliced_to_array(useState(false), 2), hasAnyEventsOccurred = _useState[0], setHasAnyEventsOccurred = _useState[1];
    var _useState1 = _sliced_to_array(useState(undefined), 2), eventData = _useState1[0], setEventData = _useState1[1];
    var _useState2 = _sliced_to_array(useState(undefined), 2), eventKey = _useState2[0], setEventKey = _useState2[1];
    var finishNotification = useCallback(function() {
        eventFinish === null || eventFinish === void 0 ? void 0 : eventFinish.publish();
        setEventKey(undefined);
        setEventData(undefined);
    }, [
        eventFinish
    ]);
    var handleNotificationStarting = useEffectEvent(function(key) {
        if (key !== eventKey) {
            finishNotification();
        }
    });
    var handleNotificationFinished = useCallback(function(key) {
        if (key === eventKey) {
            finishNotification();
        }
    }, [
        eventKey,
        finishNotification
    ]);
    var handleEvent = useCallback(function(newEventData) {
        if (shouldIgnoreEvent) {
            return;
        }
        var newEventKey = shortid.generate();
        setEventKey(newEventKey);
        setEventData(newEventData);
        setHasAnyEventsOccurred(true);
    }, [
        shouldIgnoreEvent
    ]);
    useEffect(function() {
        // Publish a new event key every time one is created
        if (eventKey) {
            NotificationStarting.publish(eventKey);
        }
    }, [
        eventKey
    ]);
    useEffect(function() {
        event.subscribe(handleEvent);
        NotificationStarting.subscribe(handleNotificationStarting);
        return function() {
            event.unsubscribe(handleEvent);
            NotificationStarting.unsubscribe(handleNotificationStarting);
        };
    }, [
        handleEvent,
        event,
        handleNotificationStarting
    ]);
    if (!eventKey || !eventData || !hasAnyEventsOccurred) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: eventHandlerElement({
            eventKey: eventKey,
            eventData: eventData,
            handleNotificationFinished: handleNotificationFinished
        })
    });
};
